import React from "react";

export default function CheckboxThemed({isChecked = true, themeColor, size = 25})
{
    return isChecked ?
        <div
            style={{
                width:`${size}px`,
                height:`${size}px`,
                background:themeColor ?? '#61849D',
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                borderRadius:'4px',
            }}
        >
            <img src={'/assets/Icon_Checkmark.svg'}/>
        </div>
        :
        <div
            style={{
                width:`${size}px`,
                height:`${size}px`,
                background:'white',
                border:`2px solid ${themeColor ?? '#61849D'}`,
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
                borderRadius:'4px',
            }}
        >
        </div>
    ;
}
